<template>
<div>
    <label class="label">Post Max Characters</label>
    <p class="help">
        How many characters a user's post can contain.
    </p>
    <div class="field is-grouped is-grouped-multiline">
        <div class="control">
            <div class="field">
                <div class="control">
                    <input
                        :value="value"
                        @input="$emit('input', Number($event.target.value))"
                        class="input"
                        type="number"
                        required/>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'PostCooldown',
    props: {
        value: Number
    },
}
</script>

<style lang="scss" scoped>
input[type="number"]{
    width: 80px;
}

.field .label {
    font-size: 0.85rem;
    font-weight: normal;
}
</style>
